<template>
  <div class="flex items-center mt-2">
    <div class="flex w-full bg-white shadow rounded">
      <input class="relative w-full px-6 py-3 rounded-r focus:ring" autocomplete="off" type="text" name="search" placeholder="Search…"  @input="$emit('update:search', $event.target.value)" />
    </div>
    <button class="ml-3 text-sm text-gray-500 hover:text-gray-700 focus:text-indigo-500" type="button" @click="$emit('reset')">Reset</button>
  </div>
</template>

<script>
export default {
  emits: ['update:search'],
  props: {
    value: String,
    search : String,
    maxWidth: {
      type: Number,
      default: 300,
    },
  },
}
</script>